import React from 'react';
import PropTypes from 'prop-types';
import HostnameCertSettingsActions from '../../containers/HostnameCertSettingsActions';

import { SETTINGS_TITLE as HOSTNAME_CERT_SETTINGS_TITLE } from '../HostnameCertSettings/HostnameCertSettings';

const propTypes = {
  setAlert: PropTypes.func.isRequired,
};

const defaultProps = {};

const SettingsActions = ({ setAlert, settingsTitle }) => {
  switch (settingsTitle) {
    case HOSTNAME_CERT_SETTINGS_TITLE:
      return <HostnameCertSettingsActions setAlert={setAlert} />;
    default:
      return null;
  }
};

SettingsActions.propTypes = propTypes;
SettingsActions.defaultProps = defaultProps;

export default SettingsActions;
